import React, { Component } from "react";

import CarrierInfo from "../../components/CarrierInfo";
import BackHeader from "../../components/BackHeader";
import hartfordLogo from "../../images/carrierIcons/carrier_logo_hartford.png";
import libertyLogo from "../../images/carrierIcons/carrier_logo_liberty_mutual.png";
import travelersLogo from "../../images/carrierIcons/carrier_logo_travelers.png";
import cnaLogo from "../../images/carrierIcons/carrier_logo_cna.png";
import natLogo from "../../images/carrierIcons/carrier_logo_nat-general.png";
import uticaLogo from "../../images/carrierIcons/carrier_logo_utica.png";
import mainLogo from "../../images/carrierIcons/carrier_logo_main-street-america.png";
import cbicLogo from "../../images/carrierIcons/carrier_logo_cbic.png";
import progressiveLogo from "../../images/carrierIcons/carrier_logo_progressive.png";
import berkshireLogo from "../../images/carrierIcons/carrier_logo_berkshire.png";

class CarrierClaim extends Component {
  backToMenu() {
    this.props.history.goBack();
  }

  render() {
    return (
      <div id="carrier-claim">
        <BackHeader text="Reference Tools" onClick={() => this.backToMenu()} />
        <h1 className="mb-4">Carrier Claim Information</h1>
        <p className="mb-4" style={{ fontSize: "14px" }}>
          Need help with a claim? <br />
          Contact the appropriate carrier directly using the information below:
        </p>
        <div>
          <CarrierInfo
            carrierLogo={hartfordLogo}
            carrierName="The Hartford"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 553-1710"
            hasAddPhone={true}
            addPhoneType="Fax"
            addPhone="(800) 347-8197"
          />
          <CarrierInfo
            carrierLogo={libertyLogo}
            carrierName="Liberty Mutual Insurance Company"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 332-3226"
            hasAddPhone={true}
            addPhoneType="All other states"
            addPhone="(877) 538-1920 opt 1"
          />
          <CarrierInfo
            carrierLogo={travelersLogo}
            carrierName="Travelers"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 635-4543"
          />
          <CarrierInfo
            carrierLogo={cnaLogo}
            carrierName="CNA"
            carrierBrand="IVANTAGE"
            carrierPhone="(877) 262-2727"
            hasAddPhone={true}
            addPhoneType="Fax"
            addPhone="(800) 953-7389"
          />
          <CarrierInfo
            carrierLogo={berkshireLogo}
            carrierName="Berkshire"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 356-5750"
          />
          <CarrierInfo
            carrierLogo={natLogo}
            carrierName="National General"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 325-1088"
          />
          <CarrierInfo
            carrierLogo={uticaLogo}
            carrierName="Utica First"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 456-4556"
            hasAddPhone={true}
            addPhoneType="Fax"
            addPhone="(315) 735-2139"
          />
          <CarrierInfo
            carrierLogo={mainLogo}
            carrierName="Main Street America"
            carrierBrand="IVANTAGE"
            carrierPhone="(877) 425-2467"
            hasAddPhone={true}
            addPhoneType="Fax"
            addPhone="(877) 282-3844"
          />
          <CarrierInfo
            carrierLogo={cbicLogo}
            carrierName="CBIC/RLI"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 788-3006"
            hasAddPhone={true}
            addPhoneType="Fax"
            addPhone="(602) 840-7678"
          />
          <CarrierInfo
            carrierLogo={progressiveLogo}
            carrierName="Progressive"
            carrierBrand="IVANTAGE"
            carrierPhone="(800) 925-2886"
          />
        </div>
      </div>
    );
  }
}

export default CarrierClaim;
